import React from 'react';
import useOverdueInvoices from "./useOverdueInvoices";
import { NoDataOverdueIcon } from "@/components/Icons";
import { toYMD } from "@/lib/utils";

const OverdueInvoices: React.FC = () => {
  const { overdueInvoices, isLoading, error } = useOverdueInvoices();

  if (isLoading) {
    return (
      <div className="w-full max-w-full mx-auto">
        <div className="bg-white rounded-lg shadow-md p-5 border border-gray-200">
          <h2 className="text-lg font-medium text-gray-800 mb-5">
            # Overdue Invoice
          </h2>
          <div className="flex items-center justify-center py-8">
            <div className="text-gray-500">Loading...</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full max-w-full mx-auto">
      <div className="bg-white rounded-lg shadow-md p-5 border border-gray-200">
        <h2 className="text-lg font-medium text-gray-800 mb-5">
          # Overdue Invoice
        </h2>

        {/* Fixed height container */}
        <div className="h-96 flex flex-col">
          {overdueInvoices.length === 0 ? (
            // No data illustration
            <div className="flex-1 flex flex-col items-center justify-center py-12">
              <NoDataOverdueIcon className="w-24 h-24 mb-4 text-gray-300" />
              <h3 className="text-lg font-medium text-gray-500 mb-2">
                No Overdue Invoices
              </h3>
              <p className="text-sm text-gray-400 text-center max-w-xs">
                All invoices are up to date.
              </p>
            </div>
          ) : (
            // Table with data
            <div className="flex-1 overflow-y-auto">
              <table className="w-full border-collapse text-sm">
                <thead className="bg-[#FFF5E9] sticky top-0 z-10">
                  <tr>
                    <th className="px-4 py-3 font-semibold text-gray-800 text-left border-b-2 border-gray-200 w-2/5">
                      School Name
                    </th>
                    <th className="px-4 py-3 font-semibold text-gray-800 text-center border-b-2 border-gray-200 w-1/3">
                      Due Date
                    </th>
                    <th className="px-4 py-3 font-semibold text-gray-800 text-center border-b-2 border-gray-200 w-1/3">
                      Invoice Owner
                    </th>
                    <th className="px-4 py-3 font-semibold text-gray-800 text-center border-b-2 border-gray-200 w-2/5">
                      Payment Received
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {overdueInvoices.map((invoice, index) => (
                    <tr
                      key={index}
                      className={`border-b border-gray-100 hover:bg-gray-50 ${
                        index % 2 === 0 ? "bg-white" : "bg-gray-50"
                      }`}
                    >
                      <td className="px-4 py-3 text-orange-500 font-medium text-left">
                        {invoice.schoolName}
                      </td>
                      <td className="px-4 py-3 text-gray-600 text-center">
                        {toYMD(invoice.expectedInvoiceClearanceDate)}
                      </td>
                      <td className="px-4 py-3 text-gray-600 text-center">
                        {invoice.invoiceOwner || "-"}
                      </td>
                      <td className="px-4 py-3 text-center">
                        <span
                          className={`inline-block px-2 py-1 rounded text-xs font-medium ${
                            invoice.paymentReceived
                              ? "text-green-700 bg-green-100"
                              : "text-red-700 bg-red-100"
                          }`}
                        >
                          {invoice.paymentReceived ? "Yes" : "No"}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OverdueInvoices;
